import styled from 'styled-components';

const StyledGrid = styled.div`
  margin-bottom: 117px;
  padding-inline: 6.94444%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-content: center;
  justify-items: center;
  row-gap: 40px;
`;

export default StyledGrid;
